import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getUnionAnchorQuitList = createAsyncThunk(
  'anchorQuitList/getUnionAnchorQuitList',
  async (
    p: {
      offset: number
      status?: number
      show_id?: string
    },
    store: any
  ) => {
    const resp = await http.post('/live/union/get_secede_union_list', {
      ...store.getState().env.deviceinfo,
      ...p,
      limit: 20,
    })
    return resp.data
  }
)

const initialState = {
  list: [],
  offset: 0,
  more: false,
}
export const anchorQuitListSlice = createSlice({
  name: 'AnchorQuitList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUnionAnchorQuitList.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
  },
})

export default anchorQuitListSlice.reducer
